document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const overlay = document.querySelector('[data-overlay]');
  const drawer = document.querySelector('[data-drawer]');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');
  const openDrawer = () => { if(drawer){ body.classList.add('drawer-open'); drawer.setAttribute('aria-hidden','false'); } };
  const closeDrawer = () => { body.classList.remove('drawer-open'); if(drawer) drawer.setAttribute('aria-hidden','true'); };
  openers.forEach(x => x.addEventListener('click', openDrawer));
  closers.forEach(x => x.addEventListener('click', closeDrawer));
  if(overlay) overlay.addEventListener('click', closeDrawer);

  document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if(menu) menu.toggleAttribute('open');
    });
  });

  document.querySelectorAll('[data-quantity]').forEach(box => {
    const input = box.querySelector('input');
    box.querySelector('[data-minus]')?.addEventListener('click',()=>{input.value=Math.max(1,Number(input.value)-1);});
    box.querySelector('[data-plus]')?.addEventListener('click',()=>{input.value=Number(input.value)+1;});
  });

  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.quickAdd;
      if(!variantId) return;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
        });
        window.location.href='/cart';
      } catch(e) {
        window.location.href='/cart';
      } finally { btn.disabled=false; }
    });
  });
});
